interface SiteLaunchResponse {
  readonly launch_url: string;
}

type SiteLaunchResult =
  { readonly ok: true } | { readonly ok: false; readonly cause: unknown };

/**
 * Mint a Site session, then hand the current tab to the exact-origin launch
 * URL returned by AppNotes. Browser Back returns the reviewer to AppNotes.
 */
export async function launchSiteReview(input: {
  readonly mint: () => Promise<SiteLaunchResponse>;
  readonly navigate: (url: string) => void;
}): Promise<SiteLaunchResult> {
  try {
    const launch = await input.mint();
    input.navigate(launch.launch_url);
    return { ok: true };
  } catch (cause) {
    return { ok: false, cause };
  }
}
